import { useTranslation } from 'react-i18next';
import type { PricingResult } from '@wrapforce/shared';
import { useLocaleFormatters } from '@/lib/format';

const BREAKDOWN_LABEL_KEYS: Record<string, string> = {
  labor: 'labor',
  material: 'material',
  design: 'design',
  print: 'print',
  correction_fee: 'correction_fee',
  fixed_add_on: 'fixed_add_on',
};

export function PricingBreakdownSidebar({ result }: { result: PricingResult }) {
  const { t } = useTranslation('quotes');
  const { formatMoney } = useLocaleFormatters();
  const visibleEntries = result.breakdown.entries.filter(
    (entry) => !((entry.label === 'design' || entry.label === 'print') && entry.cents === 0 && !entry.minutes)
  );

  return (
    <div className="flex flex-col gap-2 border border-border bg-surface-2 p-3">
      <div className="text-[10px] font-semibold uppercase tracking-[.1em] text-muted">{t('pricing.breakdown.liveBreakdown')}</div>
      <div className="flex flex-col gap-1">
        {visibleEntries.map((entry, i) => (
          <div key={i} className="flex items-center justify-between text-[12.5px]">
            <span className="text-muted">
              {BREAKDOWN_LABEL_KEYS[entry.label] ? t(`pricing.breakdown.${BREAKDOWN_LABEL_KEYS[entry.label]}`) : entry.label}
              {entry.minutes !== undefined ? <span className="ml-1 text-[10.5px]">({entry.minutes}m)</span> : null}
            </span>
            <span className="font-mono">{formatMoney(entry.cents)}</span>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between border-t border-border pt-2 text-sm font-bold">
        <span>{t('pricing.breakdown.lineTotal')}</span>
        <span className="font-mono">{formatMoney(result.lineSubtotalCents)}</span>
      </div>
      <div className="flex items-center justify-between text-xs text-muted">
        <span>{t('pricing.breakdown.estimatedTime')}</span>
        <span className="font-mono">{t('pricing.breakdown.estimatedTimeValue', { hours: (result.estimatedMinutes / 60).toFixed(1) })}</span>
      </div>

    </div>
  );
}
